jQuery(document).ready(function (e) {
  e("body");
  var t = e(document);
  e("html"), e(window);
  var i = localStorage.getItem("items")
    ? JSON.parse(localStorage.getItem("items"))
    : [];
  localStorage.getItem("compareArr") &&
    JSON.parse(localStorage.getItem("compareArr")),
    localStorage.setItem("items", JSON.stringify(i)),
    i.length && (i = JSON.parse(localStorage.getItem("items"))),
    setTimeout(function () {
      e(
        ".about_juices, .our_best, .blog_posts,.lw_short_desc, .insta_title"
      ).addClass("opened"),
        e(".best_sellers, #site_footer, #copyright").addClass("opened");
    }, 600);
    
// $(document).on('click', 'a[href="#open_cart"]', function(e) {
//   e.preventDefault();
//     window.Rebuy.SmartCart.show();
// });
  if ($('#boxcontent').length) {
    var burl = $('.blog_post_detail').data('blogurl');
        $.get(burl, function (t) {
          $("#boxcontent").html(t);
        });
  }
  var box = $('#shopify-section-article-template #product_box').length;
   if( box > 0 ){
     $('#shopify-section-article-template #product_box').each(function(){
       var t = $(this), v = t.data('urls');
        t.addClass('row'); t.addClass('justify-content-center');
       if(v){
       const urls = v.split(",");
         let text;
         for (let i = 0; i < urls.length; i++) {
          $.get( urls[i] + '?view=blog', function (quick_response) {
           t.append(quick_response);
         });
        } 
     }
     });
   }
  function url_content(url){
    return $.get(url);
  }
  var col = $('#shopify-section-article-template #productbycollection');
  var collection = col.length;
  if( collection > 0 ){
    $('#shopify-section-article-template #productbycollection').each(function(){
      var t = $(this), v = t.data('collection'); 
      t.addClass('row'); t.addClass('justify-content-center');
      url_content(v).success(function(data){ 
         var results = $(data).find('.productslist').html();
        t.html(results);
      });
    });
  }
  var s = {
    init: function () {
      this.main_menu_fixed(),
        this.mobile_menu(),
        this.mobile_tabs(),
        this.getItems(),
        this.wishlist(),
        this.wishlisticons(),
        this.ajax_pagination(),
        this.removeitems(),
        this.AddToCartRebuy();
    },
    main_menu_fixed: function () {
      e(window).scroll(function () {
        scroll = e(window).scrollTop();
        var t = e(".site-header");
        scroll >= 5 ? t.addClass("fixed") : t.removeClass("fixed");
      });
      if( redbarsticky == true ){
        e(window).scroll(function () {
          scroll = e(window).scrollTop();
          var t = e(".red_bar");
          scroll >= 5 ? t.addClass("fixed") : t.removeClass("fixed");
        });
      }
    },
    mobile_menu: function () {
      jQuery("#main_menu").prepend(
        '<span id="menu_close" class="menu_close">&times;</span>'
      ),
        jQuery(document.body).on("click", "#menuToggle", function () {
          jQuery(this).toggleClass("open"),
            jQuery("#main_menu").addClass("open"),
            jQuery("#close_div").show();
        }),
        jQuery(document.body).on("click", "#close_div", function () {
          jQuery(this).hide(),
            jQuery("#lw_side_cart, #main_menu").removeClass("open"),
            jQuery("body").removeClass("noscroll"),
            jQuery("#collection_sidebar, #main_menu").removeClass("active");
        }),
        jQuery(document.body).on("click", "#menu_close", function () {
          jQuery("#menuToggle").trigger("click"),
            jQuery("#main_menu").removeClass("open"),
            jQuery("#close_div").hide();
        }),
        jQuery("ul.sub-menu").before(
          '<span class="collspe_menu"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M192 384c-8.188 0-16.38-3.125-22.62-9.375l-160-160c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L192 306.8l137.4-137.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-160 160C208.4 380.9 200.2 384 192 384z"/></svg></span>'
        ),
        1092 > jQuery(window).width() &&
          jQuery("span.collspe_menu").prev("a").addClass("mob_menu"),
        jQuery(document.body).on("click", "span.collspe_menu", function (e) {
          e.preventDefault(), jQuery(this).next().toggle();
        });
    },
    mobile_tabs: function () {
      e('a[href="#pxaccount"]').on("click", function (t) {
        t.preventDefault(), e("[data-user-mobile-toggle]").trigger("click");
      }),
        e('a[href="#home"]').on("click", function (t) {
          t.preventDefault(),
            e("html, body").animate(
              { scrollTop: jQuery("#shopify-section-header").offset().top },
              1e3
            ),
            e('.lw_search_bar input[type="search"]').focus();
        }),
        e('a[href="#search"]').on("click", function (t) {
          t.preventDefault(),
            e(".lw_search_bar").slideToggle(),
            e('.lw_search_bar input[type="search"]').focus();
        });
    },
    getItems: function () {
 
      e.get("/cart", function (t) {
        // console.log(t);
        var content = $(t).find('#pc_cart_page').html();
        $('#pc_cart_page').html(content)
      });
      e.getJSON("/cart.json", function (t) {
        var i = Shopify.formatMoney(t.original_total_price);
        e("[data-cartcount]").text(t.item_count);
		    e("a.open_cart span").html('('+t.item_count+')'); 
        var s = i.replace("$", "");
       /* if (
          (s > 80
            ? jQuery("#cartwoomsg").html(
                "Qualified for Free Express Shipping ($80+) "
              )
            : jQuery("#cartwoomsg").html(
                "Want Free Express Shipping? Add <strong>$" +
                  (80 - s).toFixed(2) +
                  "</strong> more"
              ),
          s < 80)
        ) {
          var o = 0;
          if (0 == o) {
            o = 1;
            var a = document.getElementById("lw_Bar"),
              l = 1,
              n = setInterval(function e() {
                l >= s
                  ? (clearInterval(n), (o = 0))
                  : ++l > 100
                  ? (a.style.width = "100%")
                  : (a.style.width = l + "%");
              }, 10);
          }
        } else jQuery("#lw_Bar").css("width", "100%");
        0 == t.item_count && jQuery("#lw_Bar").css("width", "0%");*/ 
        for (let r = 0; r < t.items.length; r++) {
          jQuery('[data-prodid="' + t.items[r].id + '"]').hide(),
            jQuery('[data-hideprodID="' + t.items[r].id + '"]').hide(),
            jQuery("#btn-func-" + t.items[r].id).addClass("active"),
            jQuery("#btn-func-" + t.items[r].id)
              .find('input[type="number"]')
              .val(t.items[r].quantity),
            t.items[r].title.toLowerCase().replace(/ /g, "-");
          var c = t.items[r].line_price;
          jQuery("#price_" + t.items[r].id).text(Shopify.formatMoney(c)),
            jQuery('[data-prodid="' + t.items[r].id + '"]').val(
              t.items[r].quantity
            );
        }
        0 == t.item_count
          ? (e(".no-item-cart").show(),
            e("form.cart-form.wrapper-template-cart").hide())
          : (e(".no-item-cart").hide(),
            e("form.cart-form.wrapper-template-cart").show()),
          t.item_count > 1
            ? e("[data-cartabre]").text("are")
            : e("[data-cartabre]").text("is"),
          e(
            "#lw-sidecart .total span.price,.cart_sumary .total span.price"
          ).html(Shopify.formatMoney(t.original_total_price)),
          0 == t.items.length ? e(".no-items").show() : e(".no-items").hide(),
          e('[data-toggle="tooltip"]').tooltip();
      }),
        e.get("/cart?view=drawer", function (t) {
          e("#cartdrawer").html(t);
        });
      var t = e("a.dropdown-item.cactive").text();
      e("#tabletxt").text(t);
       
    },
    wishlist: function (o) {
      var a = e('[data-product-handle="' + o + '"]'),
        l = i.indexOf(o);
      e("#WishCounter").text(i.length),
        l >= 0
          ? (a.addClass("whislist-added"),
            a
              .find(".wishlist-text")
              .text("window.inventory_text.remove_wishlist"))
          : (a.removeClass("whislist-added"),
            a
              .find(".wishlist-text")
              .text("window.inventory_text.add_wishlist"));
      var n = "[data-icon-wishlist]";
      t.off("click.addOrRemoveWishlist", n).on(
        "click.addOrRemoveWishlist",
        n,
        function (t) {
          t.preventDefault();
          var o = e(this),
            a = o.data("id"),
            l = o.data("product-handle"),
            n = i.indexOf(l);
          o.hasClass("whislist-added")
            ? (o.removeClass("whislist-added"),
              e('[data-wishlist-added="wishlist-' + a + '"]').remove(),
              i.splice(n, 1),
              localStorage.setItem("items", JSON.stringify(i)),
              e("[data-wishlist-container]").length)
            : (o.addClass("whislist-added"),
              o
                .find(".wishlist-text")
                .text("window.inventory_text.remove_wishlist"),
              e("[data-wishlist-container]").length &&
                ella.createWishListTplItem(l),
              i.push(l),
              localStorage.setItem("items", JSON.stringify(i))),
            s.wishlist(l);
        }
      );
    },
    wishlisticons: function () {
      for (
        var t = JSON.parse(localStorage.getItem("items")), i = 0;
        i < t.length;
        i++
      )
        e('[data-product-handle="' + t[i] + '"]').addClass("whislist-added"),
          e.get("/products/" + t[i] + "?view=wishlist", function (t) {
            e("#lw_wishlist").append(t);
          });
    },
    ajax_pagination: function () {
      var t = 1;
      e(document.body).on("click", ".px-infinite-scrolling a", function (i) {
        t++,
          i.preventDefault(),
          e(this).append(
            ' <div class="spinner-border spinner-border-sm"></div>'
          ),
          e.ajax({
            type: "get",
            url: e(this).data("href"),
            beforeSend: function () {},
            success: function (t) {
              var i = e(t)
                  .find(".product-collection.fav_products ul, .blog_list ul")
                  .html(),
                s = e(t).find(".filter-form").html(),
                o = e(t).find(".px-infinite-scrolling").html();
              e(".px-infinite-scrolling").html(o),
                e(".product-collection.fav_products ul, .blog_list ul").append(
                  i
                ),
                e("#filter-form").html(s),
                e(".js-range-slider").ionRangeSlider({
                  onChange: function (t) {
                    e('input[name="filter.v.price.gte"]').val(t.from),
                      e('input[name="filter.v.price.lte"]').val(t.to);
                  },
                  onFinish: function () {
                    e("#filter-form").append(
                      '<input type="hidden" name="sort_by" value="price-ascending" />'
                    ),
                      e("#filter-form").submit();
                  },
                }),
                e(".loading-modal").hide(),
                e("div.col-sidebar .filter-group ul li").slice(0, 10).show(),
                e("div.col-sidebar .filter-groups ul li").slice(0, 10).show(),
                e("ul#filtter-health-ingredients li").slice(0, 10).show(),
                e("ul#filtter-brand li").slice(0, 10).show();
            },
            error: function (e, t) {},
            complete: function () {
              var t = e("#filter-form").serialize();
              window.history.pushState("page2", "Title", "?" + t);
            },
          });
      });
    },
    set_page_items: function () {
      e(document.body).on("click", "[data-setitemnumber] a", function (t) {
        t.preventDefault();
        var i = e(this).data("pnumber");
        e.ajax({
          type: "Post",
          url: "/cart.js",
          data: { "attributes[pagination]": i },
          success: function (e) {
            window.location.reload();
          },
          error: function (e, t) {},
          dataType: "json",
        });
      });
    },
    removeitems: function () {
      e(document.body).on(
        "click",
        "#remove-item, .item_qty a.delete,#remove-item",
        function () {
          var t = e(this).data("cart-item");
          e.ajax({
            type: "post",
            url: "/cart/change.js",
            data: "quantity=0&id=" + t,
            dataType: "json",
            success: function (e) {
              jQuery(
                '[data-product-id="' + t + '"],[data-item-id="' + t + '"]'
              ).remove(),
                jQuery("#btn-func-" + t).removeClass("active"),
                s.getItems();
                 s.remove_free_adding();
            },
            error: function (e) {},
          });
         
        }
      );
    },
    AddToCartRebuy: function () {
      document.addEventListener("rebuy.add", function () {
        s.getItems();
      });
    },
    init_free_gift: function(){
      if(free_gift==true){
        $.getJSON('/cart.js', function(cart){
            s.init_free_adding(cart);
       });
      }
    },
    init_free_adding: function(cart){
        var gift_added = false; var removeitem = false; var itemincart =  false;
        cart_total = cart.original_total_price;
        console.log('cart_total '+cart_total);
         
        for(var i = 0; i < cart.items.length; i++){
          if(cart.items[i].variant_id == free_gift_variant){
                //console.log("variant_id" + cart.items[i].variant_id);
                var itemincart = true;
          }
        }
          if(cart_total > free_gift_amount){
            var gift_added = true;
          }
          // alert(gift_added+" - "+ itemincart);
       if(gift_added==true && itemincart == false){
          $.ajax({
             type: 'POST',
             url: '/cart/add.js',
             data: {
               quantity: 1,
               id: free_gift_variant
             },
             dataType: 'json',
             success: function (data) {
               s.getItems();
             }
           });
        }
    },
    remove_free_adding: function(){
       
      $.getJSON('/cart.js', function(cart){
        var gift_added = false; var removeitem = false;
        cart_total = cart.original_total_price;

        if(cart_total < free_gift_amount){
            var removeitem = true;
          }
          if( removeitem == true ){
            $.ajax({
              type: "post",
              url: "/cart/change.js",
              data: "quantity=0&id=" + free_gift_variant,
              dataType: "json",
              success: function (e) {
                  s.getItems();
              },
              error: function (e) {},
            });
          }
          });
    },
  };
    var w = window.innerWidth;
  s.init(),
    e(document.body).on("submit", '#add-to_carts', function (t) {
      t.preventDefault();
      var i = e(this),
        o = i.serialize(),
        a = i.find('input[name="id"]').val();
      e.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: o,
        dataType: "json",
        success: function (cart) {
          e("#btn-func-" + a).addClass("active"), s.getItems();  
          // if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) { 
          // var t = document.getElementById("lw-sidecart");
          // new bootstrap.Offcanvas(t).show(); }
          
        },
      });
    }),
    e(document.body).on("click", 'a[href="#subscriber"]', function (t) {
      t.preventDefault();
      var i = e(this),
        d = i.data('produid');
      e.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: {
          id:d,
          quantity: 1,
          selling_plan:3074195630
        },
        dataType: "json",
        success: function (cart) {
          e("#btn-func-" + a).addClass("active"), s.getItems();  if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) { 
          var t = document.getElementById("lw-sidecart");
          new bootstrap.Offcanvas(t).show(); }
         
        },
      });
    }),
    e("#top_slides,#salebar").slick({
      arrows: !1,
      fade: !0,
      slidesToShow: 1,
      slidesToScroll: 1,
      cssEase: "linear",
      autoplay: !0,
    }),
    e("#mob_top_slides").slick({
      arrows: !1,
      fade: !0,
      slidesToShow: 1,
      slidesToScroll: 1,
      cssEase: "linear",
      autoplay: !0,
    }),
    e("#lw_main_slider").slick({
      infinite: !0,
      autoplay: !0,
      autoplaySpeed: 5e3,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: !0,
      arrows: false,
      prevArrow: '<button type="button" class="nhs_prev"></button>',
      nextArrow: '<button type="button" class="nhs_next"></button>',
    }),
    e(document.body).on("submit", "#add-to_cart, [data-type='add-to-cart-form']", function (t) {
      t.preventDefault();
      var i = e(this).serialize();
      e.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: i,
        dataType: "json",
        success: function (cart) {  
          // if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) { 
          // var t = document.getElementById("lw-sidecart");
          // new bootstrap.Offcanvas(t).show(); }
          s.getItems(); 
           s.init_free_gift();
        },
      });
    }),
    e(document.body).on('click', 'button[name="add"]', function(){
      
      setTimeout(()=>{
        s.init_free_gift();
         
      }, 1500 );
    });
    e(document.body).on("click", "#cls_mb_sidebar", function () {
      e("html").removeClass("sidebar-open");
    }),
    e("div.col-sidebar .filter-group ul li").slice(0, 10).show(),
    e("div.col-sidebar .filter-groups ul li").slice(0, 10).show(),
  
    e(document.body).on("click", ".filter-reset", function (t) {
      t.preventDefault();
      var i = e(this).attr("href");
      e(".loading-modal").show(),
        e.ajax({
          type: "get",
          url: "?" + i,
          beforeSend: function () {},
          success: function (t) {
            var i = e(t).find(".product-collection.fav_products ul").html(),
              s = e(t).find(".filter-form").html(),
              o = e(t).find(".px-infinite-scrolling").html();
            e(".px-infinite-scrolling").html(o),
              e(".product-collection.fav_products ul").html(i),
              e("#filter-form").html(s),
              e(".js-range-slider").ionRangeSlider({
                onChange: function (t) {
                  e('input[name="filter.v.price.gte"]').val(t.from),
                    e('input[name="filter.v.price.lte"]').val(t.to);
                },
                onFinish: function () {
                  e("#filter-form").append(
                    '<input type="hidden" name="sort_by" value="price-ascending" />'
                  ),
                    e("#filter-form").submit();
                },
              }),
              e(".loading-modal").hide(),
              e("div.col-sidebar .filter-group ul li").slice(0, 10).show(),
              e("div.col-sidebar .filter-groups ul li").slice(0, 10).show(),
              e("ul#filtter-health-ingredients li").slice(0, 10).show(),
              e("ul#filtter-brand li").slice(0, 10).show();
          },
          error: function (e, t) {},
          complete: function () {
            var t = e("#filter-form").serialize();
            window.history.pushState("page2", "Title", "?" + t);
          },
        });
    }),
    e(document.body).on(
      "click",
      'a[href="#shwmre-health-ingredients"]',
      function (t) {
        t.preventDefault();
        var i = e(this),
          s = i.text();
        "Show More" == s && e("ul#filtter-health-ingredients li").show(),
          i.text("Show less" == s ? "Show More" : "Show less").fadeIn(),
          "Show less" == s &&
            (e("ul#filtter-health-ingredients li").hide(),
            e("ul#filtter-health-ingredients li").slice(0, 10).show(),
            e("html, body").animate(
              { scrollTop: e("#shopify-section-header-parallax").offset().top },
              1e3
            ));
      }
    ),
    e(document.body).on("click", "div.filter-group h3", function () {
      e(this).toggleClass("clsdv").next().slideToggle();
    }),
    e("#filter-form").submit(function (t) {
      t.preventDefault();
      var i = e(this).serialize();
      window.history.pushState("page2", "Title", "?" + i),
        window.location.pathname,
        e(".loading-modal").show(),
        e(".px-infinite-scrolling").html(""),
        e.ajax({
          type: "get",
          url: "?" + i,
          success: function (t) {
            var i = e(t).find(".product-collection.fav_products ul").html(),
              s = e(t).find(".filter-form").html(),
              o = e(t).find(".px-infinite-scrolling").html();
            e(".px-infinite-scrolling").html(o),
              e(".product-collection.fav_products ul").html(i),
              e("#filter-form").html(s),
              e(".loading-modal").hide(),
              e("div.col-sidebar .filter-group ul li").slice(0, 10).show(),
              e("div.col-sidebar .filter-groups ul li").slice(0, 10).show(),
              e("ul#filtter-health-ingredients li").slice(0, 10).show(),
              e("ul#filtter-brand li").slice(0, 10).show(),
              e(".js-range-slider").ionRangeSlider({
                onChange: function (t) {
                  e('input[name="filter.v.price.gte"]').val(t.from),
                    e('input[name="filter.v.price.lte"]').val(t.to);
                },
                onFinish: function () {
                  e("#filter-form").submit();
                },
              });
          },
          error: function (e, t) {},
          complete: function () {},
        });
    }),
    e(document.body).on(
      "change",
      '#filter-form input[type="checkbox"]',
      function (t) {
        t.preventDefault(),
          setTimeout(function () {
            e("#filter-form").submit();
          }, 500);
      }
    ),
    e(document.body).on("click", "#lw_addcart", function (t) {
      var i = e(this).attr("data-id");
      t.preventDefault(),
        (datass = { id: i, quantity: 1 }),
        e.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: datass,
          dataType: "json",
          success: function (e) {
          //   if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) { 
          //   var t = document.getElementById("lw-sidecart"); 
          // new bootstrap.Offcanvas(t).show(); }
            s.getItems();
            s.init_free_gift();
          },
        });
    }),
    e(document.body).on("click", ".pc_sidebar h3", function () {
      var t = e(this);
      t.next().slideToggle(),
        t.parent().siblings().find("h3").removeClass("active"),
        t.parent().siblings().find(".filter-group-display").slideUp(),
        t.toggleClass("active");
    }),
    e(".pc_product_sorting span.sorting").on("click", function () {
      e("#pc_sidebar").addClass("active");
    }),
    e("#filter_close").on("click", function () {
      e("#pc_sidebar").removeClass("active");
    }),
    e(document.body).on("click", "[data-plus]", function (t) {
      t.preventDefault();
      var i = e(this),
        o = i.siblings('input[type="number"]'),
        a = (o.data("max"), i.data("id")),
        l = parseInt(o.val()) + 1;
      o.val(l),
        "" != a &&
          e.ajax({
            type: "post",
            url: "/cart/change.js",
            data: "quantity=" + l + "&id=" + a,
            dataType: "json",
            success: function (e) {
              s.getItems();
            },
            error: function (e) {},
          });
    }),
    e(document.body).on("click", "[data-minus]", function (t) {
      t.preventDefault();
      var i = e(this);
      let o = i.siblings('input[type="number"]'),
        a = parseInt(o.val()) - 1,
        l = i.data("id");
      a > 0 && o.val(a),
        "" != l &&
          e.ajax({
            type: "post",
            url: "/cart/change.js",
            data: "quantity=" + a + "&id=" + l,
            dataType: "json",
            success: function (e) {
              s.getItems();
            },
            error: function (e) {},
          });
    }),
    e(document.body).on("click", 'a[href="#mobile_filter"]', function (t) {
      t.preventDefault(),
        e("#collection_sidebar").toggleClass("active"),
        e("#close_div").show(),
        e("body").addClass("menu_active");
    });
  var o = 1;
  e(document.body).on("click", ".blog_showmore a", function (t) {
    o++, t.preventDefault();
    var i = e(this),
      s = i.data("totalpages");
    i.after('<div id="loader" class="spinner-grow text-dark"></div>'),
      o <= s &&
        e.ajax({
          type: "get",
          url: "https://littlewest.com/blogs/posts/?page=" + o,
          success: function (t) {
            var i = e(t).find(".ve_news_list").html();
            e("#ve_news_list").append(i);
          },
          complete: function () {
            e("#loader").remove();
          },
        }),
      o == s && i.hide();
  }),
    e(".drink_tabs li").on("click", function () {
      e(this).addClass("active"), e(this).siblings().removeClass("active");
      var t = e(this).attr("data-tab");
      e("#" + t).addClass("active"),
        e("#" + t)
          .siblings()
          .removeClass("active");
    }),
    e("[data-parsonslist]").slick({
      dots: !1,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: !1,
      responsive: [
        { breakpoint: 1100, settings: { slidesToShow: 3, slidesToScroll: 1 } },
        { breakpoint: 769, settings: { slidesToShow: 2, slidesToScroll: 1 } },
        { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1 } },
      ],
    }),
    e("#lw_asseen").slick({
      dots: !1,
      speed: 500,
      slidesToShow: 6,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 2000,
      slidesToScroll: 1,
      arrows: !1,
      responsive: [
        { breakpoint: 1100, settings: { slidesToShow: 5, slidesToScroll: 1 } },
        { breakpoint: 800, settings: { slidesToShow: 4, slidesToScroll: 1 } },
        { breakpoint: 769, settings: { slidesToShow: 3, slidesToScroll: 1 } },
      ]
    });

    // Optionally, you can manually destroy the slider below 800px
    function checkSliderVisibility() {
      if (window.innerWidth < 800) {
        if (e("#lw_asseen").hasClass('slick-initialized')) {
          e("#lw_asseen").slick('unslick');
        }
      } else {
        if (!e("#lw_asseen").hasClass('slick-initialized')) {
          // Re-initialize if needed
        }
      }
    }

    // Check on load and resize
    checkSliderVisibility();
    e(window).on('resize', checkSliderVisibility);
    e("[data-ambassador-products]").slick({
      dots: !1,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: !1,
      responsive: [
        { breakpoint: 1100, settings: { infinite:true,slidesToShow: 3, slidesToScroll: 1 } },
        {
          breakpoint: 769,
          settings: { infinite:true,slidesToShow: 2, slidesToScroll: 2 },
        }
      ],
    });
    e("#blogscroll").slick({
      dots: !1,
      speed: 500, infinite:true,
      slidesToScroll: 1,
      variableWidth:true,
      arrows: !1,autoplay:true,autoplaySpeed: 3000,
      responsive: [
        { breakpoint: 1100, settings: {slidesToShow: 3, slidesToScroll: 1 } },
        {
          breakpoint: 769,
          settings: { infinite:true,slidesToShow: 2, slidesToScroll: 1 },
        }
      ],
    });
    if( w > 991 ){
      e(".blogscroll.boost-immunity").slick({
        dots: !1,
        speed: 500, infinite:true,
        slidesToScroll: 1,
        variableWidth:true,
        arrows: !1,autoplay:true,autoplaySpeed: 3000,
        responsive: [
          { breakpoint: 1100, settings: {slidesToShow: 3, slidesToScroll: 1 } },
          {
            breakpoint: 769,
            settings: { infinite:true,slidesToShow: 2, slidesToScroll: 1 },
          }
        ],
      }); 
    }
    if(w > 600){
      
    e("#grid_blog").slick({
      arrows: !1,
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: !0,infinite: false,
      speed: 300,dots:false,
      responsive: [
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
        }
      },
    ]
    });
    }
    e("#blog_styletwo").slick({
      dots: !1,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth:true,infinite:true,
      arrows: !1,
      responsive: [
        { breakpoint: 1100, settings: {slidesToShow: 3, slidesToScroll: 1 } },
        {
          breakpoint: 769,
          settings: { slidesToShow: 2, slidesToScroll: 2 },
        }
      ],
    });
  e("#bbproducts_scroll").slick({
      dots: !1,
      speed: 500, infinite:true,
      slidesToScroll: 1,
      variableWidth:true,
      arrows: true,
      prevArrow: '<span class="bbprev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 246.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"/></svg></span>',nextArrow:'',
      responsive: [
        { breakpoint: 1490, settings: {dots: true,arrows:false } },
      ],
    });
    if( w > 768 ){
      
    e("#products_scroll").slick({
      dots: !1,
      speed: 500, infinite:true,
      slidesToScroll: 1,
      variableWidth:true,
      arrows: !1,autoplay:true,autoplaySpeed: 3000,
      responsive: [
        { breakpoint: 1100, settings: {slidesToShow: 3, slidesToScroll: 1 } },
        {
          breakpoint: 769,
          settings: { infinite:true,slidesToShow: 2, slidesToScroll: 2 },
        }
      ],
    });
    e("#productsscroll").slick({
      dots: !1,
      speed: 500, infinite:true,
      slidesToScroll: 1,
      variableWidth:true,
      arrows: !1,autoplay:true,autoplaySpeed: 3000,
      responsive: [
        { breakpoint: 1100, settings: {slidesToShow: 3, slidesToScroll: 1 } },
        {
          breakpoint: 769,
          settings: { infinite:true,slidesToShow: 2, slidesToScroll: 2 },
        }
      ],
    });
    
    e("#energy_products").slick({
      dots: !1,
      speed: 500, infinite:false,
      slidesToScroll: 1,
      slidesToShow: 4,
      arrows: !1,autoplay:true,autoplaySpeed: 3000,
      responsive: [
        { breakpoint: 1100, settings: {slidesToShow: 3, slidesToScroll: 1 } },
        {
          breakpoint: 769,
          settings: {slidesToShow: 2, slidesToScroll:1, infinite:false },
        },
        {
          breakpoint: 620,
          settings: {slidesToShow: 2, slidesToScroll:1, infinite:false },
        }
      ],
    });
    }
  
    e('a[href="#recover"]').on("click", function (t) {
      t.preventDefault(),
        e("#CustomerLoginForm").hide(),
        e("#RecoverPasswordForm").show();
    }),
    e('a[href="#LoginHeading"]').on("click", function (t) {
      t.preventDefault(),
        e("#RecoverPasswordForm").hide(),
        e("#CustomerLoginForm").show();
    });
    $('.lw_sidebar li:first-child').addClass('active');
    $(document.body).on('click', '.lw_sidebar li a', function(e){ e.preventDefault();
      var t = $(this); var id = t.attr('href');
      t.parent().addClass('active').siblings().removeClass('active');
      jQuery('html, body').animate({
          scrollTop: jQuery(id).offset().top - 100
      }, 1000); 
    });
    
    document.addEventListener("rebuy:smartcart.line-item-increase", (event) => {
      const smartcart = event.detail.smartcart; // full Smart Cart state
      const item = event.detail.item;           // the specific item changed
       
      s.init_free_gift();
    });

    document.addEventListener("rebuy:smartcart.line-item-decrease", (event) => {
      const smartcart = event.detail.smartcart;
      const item = event.detail.item;
       
      s.init_free_gift(); 
      s.remove_free_adding();
    }); 
    document.addEventListener('rebuy:smartcart.line-item-removed', (event) => {
      const { smartcart, item } = event.detail;
      s.remove_free_adding(); s.init_free_gift(); 
    });
});